// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(min-width:768px){.CurrencySwitcher{background-color:transparent;border:1px solid #c6226f;border-radius:.375rem;margin-right:.5rem;padding:.55rem 1rem;width:auto}.CurrencySwitcher--dropdown>.CurrencySwitcher__selected{margin-left:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
